module.exports = __webpack_public_path__ + "a7034cfd9684c03dc5cf4c9d6cc95ca4.jpg";